import HTML from '../../img/icon/html.svg';
import JS from '../../img/icon/js.svg';
import ReactIcon from '../../img/icon/react.svg';
import CSSIcon from '../../img/icon/css.svg';
import NetsuiteIcon from '../../img/icon/netsuite-.png'
import ExpressJsIcon from '../../img/icon/expressjs.svg';
/*
import ArrowUp from '../../img/icon/arrow-up.svg';
import Code from '../../img/icon/code.svg';
import ExternalLink from '../../img/icon/external-link.svg';
import Figma from '../../img/icon/figma.svg';
import Github from '../../img/icon/github.svg';
import Gulp from '../../img/icon/gulp.svg';
import LinkedIn from '../../img/icon/linkedin.svg';
import Location from '../../img/icon/location.svg';
import Mail from '../../img/icon/mail.svg';
import Rocket from '../../img/icon/rocket.svg';
import Sass from '../../img/icon/sass.svg';
import Skype from '../../img/icon/skype.svg';
import Telegram from '../../img/icon/tg.svg';
import TypeScript from '../../img/icon/typescript.svg';
import GoogleMaps from '../../img/icon/google-maps.svg';
import Jinja from '../../img/icon/jinja.svg';
import Less from '../../img/icon/less.svg';
import Linkify from '../../img/icon/linkify.svg';
import RapidApi from '../../img/icon/rapid-api.svg';
import SimpleBar from '../../img/icon/simple-bar.svg';
import Pusher from '../../img/icon/pusher.svg';
import Upstash from '../../img/icon/upstash.svg';
import Redis from '../../img/icon/redis.svg';
import Tailwindcss from '../../img/icon/tailwindcss.svg';
import Gsap from '../../img/icon/gsap.svg';
import Codepen from '../../img/icon/codepen.svg';
import Prisma from '../../img/icon/prisma.svg';
import Stripe from '../../img/icon/stripe.svg';
*/
const Icons = {
  IconHtml: HTML,
  IconJs: JS,
  IconCss: CSSIcon,
  IconReact: ReactIcon,
  IconExpressJs: ExpressJsIcon,
  IconNetsuite: NetsuiteIcon
  /*arrowUp: ArrowUp,
  code: Code,
  css: CSS,
  externalLink: ExternalLink,
  figma: Figma,
  github: Github,
  gulp: Gulp,
  html: HTML,
  linkedIn: LinkedIn,
  location: Location,
  mail: Mail,
  nextjs: NextJs,
  react: React,
  rocket: Rocket,
  sass: Sass,
  skype: Skype,
  telegram: Telegram,
  typescript: TypeScript,
  'google-maps': GoogleMaps,
  jinja: Jinja,
  less: Less,
  linkify: Linkify,
  'rapid-api': RapidApi,
  'simple-bar': SimpleBar,
  pusher: Pusher,
  upstash: Upstash,
  redis: Redis,
  tailwindcss: Tailwindcss,
  'green-sock': Gsap,
  codepen: Codepen,
  prisma: Prisma,
  stripe: Stripe*/
};


export default Icons;
